import create from 'zustand';
import { LocalStorageKey, localStorageUtil } from '../utils/localStorage';

export type ThemeNames = 'dianaDark' | 'dianaLight';

export interface ThemeStore {
    themeName: ThemeNames;
    setTheme: (payload: ThemeNames) => void;

    primaryColor: string | null;
    setPrimaryColor: (payload: string) => void;
}

export const defaultTheme = localStorageUtil.getItem({
    key: LocalStorageKey.defaultTheme,
}) as ThemeNames;

export const useThemeStore = create<ThemeStore>((setState) => ({
    themeName: defaultTheme || 'dianaDark',
    setTheme: (payload) => setState(() => ({ themeName: payload })),

    primaryColor: null,
    setPrimaryColor: (payload) => setState({ primaryColor: payload }),
}));
